import {
  API_ONE_ON_ONE_ME,
  API_ONE_ON_ONE_ORGANIZED_BY_ME,
  API_ONE_ON_ONE_FROM_MY_DIRECT_REPORTS,
  API_ACTION_PLANS_ME,
  API_ACTION_PLANS_ME_CREATED_BY_ME,
  API_ACTION_PLANS_FROM_MY_DIRECT_REPORTS,
} from './apiRoutes';
import { FIELD_TYPES } from './fieldTypes';
import { isArrayEmpty } from '../utility/helpers';
import {
  isEmpty,
  validateLength,
  forbiddenCharacters,
} from '../utility/validation';

export const DASHBOARD_TASKS_PRESET = 'DASHBOARD_TASKS';

export const CARD_TIME_DATE_FORMAT = 'h:mm a, MMM d, yyyy';

export const CARD_DATE_FORMAT = 'MMM d, yyyy';

export const MAX_MOOD_LENGTH = 6;

export const MOOD_PLACEHOLDER = {
  placeholderValue: 5,
};

export const DASHBOARD_DEFAULT_PARAMS = {
  page: 1,
  page_size: 10,
};

export const MY_COURSES_ORDERING = { ordering: 'course__title' };

export const TO_DO_ENTITIES = {
  PLAN: 'PLAN',
  ONE_ON_ONE: '1:1',
  SURVEY: 'SURVEY',
  ABSENCE_REQUEST: 'ABSENCE_REQUEST',
};

export const MANAGE_TEAM_FIELDS = [
  {
    name: 'name',
    type: FIELD_TYPES.TEXT,
    translationKey: 'name',
    required: true,
    validators: [
      { type: 'required', validator: isEmpty },
      { type: 'forbiddenCharacters', validator: forbiddenCharacters },
      {
        type: 'nameMaxLength',
        validator: validateLength,
      },
    ],
  },
  {
    name: 'users',
    type: FIELD_TYPES.PEOPLE_PICKER,
    translationKey: 'users',
    optionsKey: 'allUsers',
    hasSelectAll: true,
    required: true,
    showDirectReports: true,
    showSelection: true,
    shouldCalculateSelectionHeight: true,
    shouldRemoveFieldSpacing: true,
    shouldRemoveFieldError: true,
    validators: [
      { type: 'required', validator: value => !isArrayEmpty(value) },
    ],
  },
];

export const INITIAL_TEAM_DATA = {
  name: '',
  users: [],
};

export const DASHBOARD_1_1_TABS = [
  {
    id: 1,
    name: 'My 1:1s',
    url: API_ONE_ON_ONE_ME,
    key: 'myOneOnOne',
  },
  {
    id: 2,
    name: 'Organized by me',
    url: API_ONE_ON_ONE_ORGANIZED_BY_ME,
    key: 'organizedByMe',
  },
  {
    id: 3,
    name: 'Team’s 1:1s',
    url: API_ONE_ON_ONE_FROM_MY_DIRECT_REPORTS,
    key: 'teamOneOnOne',
  },
];

export const DASHBOARD_PLAN_TABS = [
  {
    id: 1,
    name: 'My Action plans',
    url: API_ACTION_PLANS_ME,
    key: 'myPlans',
  },
  {
    id: 2,
    name: 'Created by me',
    url: API_ACTION_PLANS_ME_CREATED_BY_ME,
    key: 'createdByMe',
  },
  {
    id: 3,
    name: "Team's Action plans",
    url: API_ACTION_PLANS_FROM_MY_DIRECT_REPORTS,
    key: 'teamPlans',
  },
];
